import { Pipe, PipeTransform } from '@angular/core';
import type { ProductMenu } from '../../../../../models/menu/product-menu';
import { SectionColumnProductInfoType } from '../../../../../models/enum/shared/section-column-product-info-type';
import type { SectionColumnViewModel } from '../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';

@Pipe({
  name: 'hideLabelColumn',
  standalone: false
})
export class HideLabelColumnPipe implements PipeTransform {
  transform(colVM: SectionColumnViewModel, menu: ProductMenu, labelText: string): boolean {
    return colVM.columnType === SectionColumnProductInfoType.Label && menu?.hideProductLabelColumnWhenEmpty()
      ? !labelText
      : false;
  }
}
